
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";

@Component({
  components: { Typewriter },
})
export default class Title extends Vue {
  segment0 = false;
  segment1 = false;
  segment2 = false;
  segment3 = false;
  sound = localStorage.sound === 'true' ?? false;

  defeat = require("@/audio/Defeat_Jingle.mp3")
}
